var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb p-0 m-0"},_vm._l((_vm.treeData),function(i){return _c('li',{key:i.id,staticClass:"breadcrumb-item"},[_vm._v(" "+_vm._s(i.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }